import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';

const projectImages = [
    {
        src: '/images/bousanm-preview-1.webp',
        alt: 'Interface principale',
        title: 'Page d\'accueil',
        description: 'Interface élégante présentant les services de paiement et de transfert d\'argent de Bousanm'
    },
    {
        src: '/images/bousanm-login.webp',
        alt: 'Connexion',
        title: 'Connexion',
        description: 'Système d\'authentification sécurisé avec une interface moderne pour accéder à votre compte Bousanm'
    },
    {
        src: '/images/inscription.webp',
        alt: 'Inscription',
        title: 'Inscription',
        description: 'Processus d\'inscription simplifié permettant de créer votre compte Bousanm en quelques étapes, avec vérification d\'identité sécurisée'
    }
];

const LatestProject = () => {
    return (
        <section className="py-16 bg-white dark:bg-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Informations du projet à gauche */}
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                        className="space-y-6"
                    >
                        <div className="inline-block">
                            <span className="bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-400 text-sm font-medium px-3 py-1 rounded-full">
                                Dernier Projet
                            </span>
                        </div>

                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                            Bousanm - Plateforme Fintech
                        </h2>

                        <p className="text-xl text-gray-600 dark:text-gray-300">
                            Solution innovante de paiement numérique et de transfert d'argent, conçue pour simplifier les transactions financières en Haïti.
                        </p>

                        <div className="space-y-4">
                            <div className="flex items-center space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <span className="text-gray-700 dark:text-gray-300">Transactions sécurisées et instantanées</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <span className="text-gray-700 dark:text-gray-300">Gestion simplifiée de votre portefeuille numérique</span>
                            </div>
                            <div className="flex items-center space-x-3">
                                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <span className="text-gray-700 dark:text-gray-300">Suivi en temps réel de vos transactions</span>
                            </div>
                        </div>

                        <div className="pt-4">
                            <Link
                                to="/portfolio"
                                className="inline-flex items-center space-x-2 text-blue-600 dark:text-blue-400 font-medium hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-200"
                            >
                                <span>Voir plus de projets</span>
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </Link>
                        </div>
                    </motion.div>

                    {/* Carte d'images à droite */}
                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}
                        className="relative"
                    >
                        <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden shadow-2xl">
                            <div className="group relative h-[400px] bg-gradient-to-br from-blue-500 to-blue-600 p-1 transition-transform duration-300 hover:scale-[1.01]">
                                <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                <div className="relative h-full rounded-xl overflow-hidden bg-gray-900">
                                    <Carousel images={projectImages} />
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default LatestProject;